
/**
 * @roxi/routify 2.18.12
 * File generated Sat Apr 29 2023 15:20:56 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "2.18.12"
export const __timestamp = "2023-04-29T15:20:56.160Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports
import _aboutPartTimeInstructor from '../src/pages/about-part-time-instructor.md'
import _aboutProgramming from '../src/pages/about-programming.md'
import _aboutResearchAndDevelopment from '../src/pages/about-research-and-development.md'
import _index from '../src/pages/index.svelte'
import _nested from '../src/pages/nested.svelte'
import _subpage from '../src/pages/subpage.svelte'
import __layout from '../src/pages/_layout.svelte'

//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "ext": "md",
      "isPage": true,
      "path": "/about-part-time-instructor",
      "id": "_aboutPartTimeInstructor",
      "component": () => _aboutPartTimeInstructor
    },
    {
      "ext": "md",
      "isPage": true,
      "path": "/about-programming",
      "id": "_aboutProgramming",
      "component": () => _aboutProgramming
    },
    {
      "ext": "md",
      "isPage": true,
      "path": "/about-research-and-development",
      "id": "_aboutResearchAndDevelopment",
      "component": () => _aboutResearchAndDevelopment
    },
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => _index
    },
    {
      "isPage": true,
      "path": "/nested",
      "id": "_nested",
      "component": () => _nested
    },
    {
      "isPage": true,
      "path": "/subpage",
      "id": "_subpage",
      "component": () => _subpage
    }
  ],
  "isLayout": true,
  "path": "/",
  "id": "__layout",
  "component": () => __layout
}


export const {tree, routes} = buildClientTree(_tree)

